import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { HoverableIconComponent } from "./types";

export const DeleteIcon: HoverableIconComponent = (props) => {
  const { isHovered, ...restOfProps } = props;
  return (
    <FontAwesomeIcon
      {...restOfProps}
      icon={faTrash}
      color={isHovered ? "#FFFFFF" : "#639AF8"}
    />
  );
};
